import { render, staticRenderFns } from "./swiper-news-home-small.vue?vue&type=template&id=4bf25c5c&scoped=true"
import script from "./swiper-news-home-small.vue?vue&type=script&lang=js"
export * from "./swiper-news-home-small.vue?vue&type=script&lang=js"
import style0 from "./swiper-news-home-small.vue?vue&type=style&index=0&id=4bf25c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf25c5c",
  null
  
)

export default component.exports